module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_9.a7a47deb.pdf";